export default __webpack_public_path__ + "static/media/login.ee9304a8.jpg";